<template>
  <!-- fi-plan-board: the root hook the midnight skin scopes the planned-board
       rules on. its siblings all carry it; this page was missed. -->
  <div class="fi-plan-board" style="margin:20px">
    <FiPageRail title="Planned - Driver Dispatch Weekly" />

    <div style="position: relative; font-weight: bold; font-size: 20px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;Filter&nbsp;<b-form-input style="width: 200px" v-model="driver_filter"/>
    </div>
    <br/>
    <vue-html2pdf
        :enable-download="true"
        :manual-pagination="true"
        :filename="'drivers-dispatch-weekly-' + details_fromDate"
        pdf-format="letter"
        margin="0px"
        pdf-orientation="landscape"
        pdf-content-width="1000px"
        ref="html2Pdf"
    >
      <section slot="pdf-content">
        <html>
        <template v-for="page in Array(Math.ceil(items.length / 30)).keys()">
          <section class="pdf-item">
            <table border="1">
              <tr style="font-size: 14px">
                <th style="min-width: 130px;max-width: 130px">Drivers</th>
                <th style="min-width: 130px;max-width: 130px" align="center" v-for="day_record in summary.date_cols">
                  {{day_record.date_month}}/{{day_record.date_day}} - {{day_record.date_weekday}}
                </th>
              </tr>
              <template v-if="idx >= (page * 30) && idx < ((page+1)*30)" v-for="(driver_record,idx) in items">
                <tr>
                  <td :style="'background-color:' + driver_record.colorcode" style="font-size: 12px; font-weight: bold;">{{driver_record.driver}}</td>
                  <td :style="date_record.assignments.length > 0 && date_record.assignments[0].multiday ? 'background-color: #E2E2E2': ''" style="font-size: 12px;" v-for="date_record in driver_record.date_records">
                    <span v-for="assignment,idx in date_record.assignments">
                      <br v-if="idx > 0"/>
                      <span style="color: red" v-if="assignment.absence_info">
                        {{assignment.absence_info | trim(20)}}
                        <span v-if="assignment.absence_time"><br/>{{assignment.absence_time}}</span>
                      </span>
                      <span style="color: darkmagenta" v-if="assignment.availability_info">
                        {{assignment.availability_info | trim(20)}}
                      </span>
                      <span v-else>
                        {{assignment.assignment_info | trim(20)}}
                      </span>
                    </span>
                  </td>
                </tr>
              </template>
            </table>
            <br/>
            <table width="1000px">
              <tr>
                <td>Page {{page+1}} of {{Math.ceil(items.length/30)}}</td>
                <td align="right">{{current_date}}</td>
              </tr>
            </table>
          </section>

          <div v-if="page+1 != Math.ceil(items.length/30)" class="html2pdf__page-break"/>
          <br/>

        </template>

        </html>
      </section>
    </vue-html2pdf>

        <div v-if="!loading">

          <div class="row" style="margin: 10px; font-weight: bold; font-size: 20px;">
            <template v-for="type_stat in summary.driver_type_stats">
              <div @click="filter_by_type(type_stat.type)" class="col" :style="{ 'background': type_stat.color }">{{type_stat.type}}</div>
            </template>
            <div style="margin-left: 10px" @click="printPage()"><img height="30px" src="/print-icon.png"/></div>
          </div>
          <br/>
          <table border="1">
            <tr style="font-size: 22px">
                <th style="min-width: 235px;max-width: 235px">Drivers</th>
                <th style="min-width: 235px;max-width: 235px" v-for="day_record in summary.date_cols">
                  {{day_record.date_month}}/{{day_record.date_day}} - {{day_record.date_weekday}}
                </th>
            </tr>
            <template style="font-size: 16px" v-if="!selected_type || selected_type==driver_record.driver_type" v-for="driver_record in items">
              <tr v-on:click="toggle_div(driver_record.driver)" >
                <td :style="'background-color:' + driver_record.colorcode" style="font-weight: bold;">{{driver_record.driver}}</td>
                <td :style="date_record.assignments.length > 0 && date_record.assignments[0].multiday ? 'background-color: #E2E2E2': ''" v-for="date_record in driver_record.date_records">
                  <span v-for="assignment,idx in date_record.assignments">
                    <hr v-if="idx > 0"/>
                    <span style="color: red" v-if="assignment.absence_info">
                      {{assignment.absence_info}}
                      <span v-if="assignment.absence_time"><br/>{{assignment.absence_time}}</span>
                    </span>
                    <span style="color: darkmagenta" v-if="assignment.availability_info">
                      {{assignment.availability_info}}
                    </span>
                    <span v-else>
                      {{assignment.assignment_info}}
                    </span>
                  </span>
                </td>
              </tr>
              <tr :style="driver_expanded == driver_record.driver ? '' : 'display:none'">
                <td>&nbsp;</td>
                <td style="borderbackground: lightgray" valign="top" align="left" v-for="date_record in driver_record.date_records">
                  <span v-if="assignment.assignment_info" v-for="assignment,idx in date_record.assignments">
                    <hr v-if="idx > 0"/>
                    <b>BookingID:</b> {{assignment.charterID}}<br/>
                    <b>Vehicle:</b> {{assignment.vehicle}}<br/>
                    <b>Destination:</b> {{assignment.destination}}<br/>
                    <b>Start:</b> {{assignment.start_datetime | formatDateTimeSmall(assignment.timezone)}}<br/>
                    <b>Finish:</b> {{assignment.finish_datetime | formatDateTimeSmall(assignment.timezone)}}
                  </span>
                </td>
              </tr>
            </template>
          </table>
        </div>
        <div v-else>
          <br/><br/>
          <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
        </div>
  </div>
</template>
<script>
import {get_tbn_drivers_dispatch_weekly} from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'planned_drivers_weekly_dispatch_tbn',

  components: {
    VueHtml2pdf
  },

  data() {
    return {
      items: [],
      items_full: [],
      summary: [],
      driver_filter: '',
      loading: true,
      current_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      details_fromDate: justDate(moment()),
      selected_type: null,
      driver_expanded: null,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    printPage() {
      //window.print();
      this.$refs.html2Pdf.generatePdf()
    },
    async check_features() {
      this.load_data()
    },
    showHighlightsForDate(movements) {
      for(const item of movements) {
        item.isHighlightsVisible = !item.isHighlightsVisible;
      }
      this.$forceUpdate();
    },
    filter_items() {
      this.items = this.items_full
      if (this.selected_type)
        this.items = this.items.filter(item => item.driver_type == this.selected_type)
      if (this.driver_filter)
        this.items = this.items.filter(item => (this.contains(item.driver, this.driver_filter)))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    filter_by_type(type) {
      if (type == null || this.selected_type == type) {
        this.selected_type = null
      } else {
        this.selected_type = type
      }
    },
    showDetailsForDate(movements) {
      for(const item of movements) {
        item.isVisible = !item.isVisible;
      }
      this.$forceUpdate();
    },
    toggle_div(item,field) {
      if (this.driver_expanded == item)
          this.driver_expanded = null;
      else
          this.driver_expanded = item;
      this.$forceUpdate();
    },
    async load_data() {

      this.loading = true
      try {
        const { value: { data = [] }} = await get_tbn_drivers_dispatch_weekly(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    getStyleForDriverID(color) {
      if (color != null)
        return 'background-color:' + color
      return '';
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    driver_filter() {
      this.filter_items()
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.details_toDate = justDate(moment(target_from_date,'MM-DD-YYYY').add(27, 'days'));
      this.load_data();
    }
  }
}
</script>

<style scoped>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }

th {
  position: sticky;
  top: 0;
  background-color: #F9F8F8;
  border: 1px solid black;
}

tr>th:first-child,tr>td:first-child {
  position: sticky;
  left: 0;
}
</style>
